import React from 'react';
import BackButton from '../../components/back-button';
import H1 from '../../components/h1';
import aboutPage from '../../contentful/aboutPage.json';
import Markdown from '../../components/markdown';
import styles from './about.module.scss';
import { findDOMNode } from 'react-dom';
import safeGa from '../../modules/safeGa';

const linksToForceToButtons = [
  'View the Recommendations',
  'Read the summary document',
];

const renderBlueBox = className => {
  return (
    <div className={styles.violetBox}>
      <h4>The Vision</h4>
      <q>
        The right infrastructure, in the right places, that is well managed and
        put to good use, boosting productivity, global competitiveness, and
        improving the quality of people’s lives.
      </q>
    </div>
  );
};
const renderSidebar = sidebarImages => {
  return (
    <React.Fragment>
      {sidebarImages.map((sidebarImg, i) => {
        return (
          <img
            key={i}
            className={styles.img}
            alt={'/contentful/' + sidebarImg.altText}
            src={'/contentful/' + sidebarImg.filename}
          />
        );
      })}
    </React.Fragment>
  );
};
class AboutPage extends React.Component {
  componentDidMount() {
    safeGa('set', 'page', '/about.html');

    safeGa('send', 'pageview');
    // This hack forces some of the links in the text to appear like buttons
    const markdownElement = findDOMNode(this.markdown);
    Array.from(markdownElement.querySelectorAll('a'))
      .filter(d => linksToForceToButtons.includes(d.innerHTML))
      .forEach(button => {
        button.classList.add(styles.markdownButton);
      });
    Array.from(markdownElement.querySelectorAll('a')).forEach(
      link => (link.target = '_blank')
    );
  }

  render() {
    const sidebarImages = aboutPage.sidebarImages || [];
    return (
      <div>
        <BackButton />
        <div className={styles.row}>
          <div className={styles.leftContent}>
            <H1>About the strategy</H1>
            <Markdown
              className={styles.markdown}
              content={aboutPage.initialText}
            />
            <div className="mobileOnly">{renderBlueBox()}</div>
            <img
              className={styles.img}
              alt={'/contentful/' + aboutPage.initialImage.altText}
              src={'/contentful/' + aboutPage.initialImage.filename}
            />
            <Markdown
              ref={r => (this.markdown = r)}
              className={styles.markdown}
              content={aboutPage.content}
            />
            {aboutPage.bottomimage ? (
              <img
                className={styles.img}
                alt={'/contentful/' + aboutPage.bottomImage.altText}
                src={'/contentful/' + aboutPage.bottomImage.filename}
              />
            ) : null}

            <div className="mobileOnly">{renderSidebar(sidebarImages)}</div>
          </div>
          <div className={`desktopOnly ${styles.rightContent}`}>
            {renderBlueBox()}
            {renderSidebar(sidebarImages)}
          </div>
        </div>
      </div>
    );
  }
}
export default AboutPage;



// WEBPACK FOOTER //
// ./src/pages/about/about.js